import {defineMessages} from 'react-intl'

/**
 * Los doce meses, en orden (índice 0 = enero), como descriptores reutilizables.
 *
 * Varias pantallas venían repitiendo su propio array `MONTH_IDS`/`MONTH_DEFAULTS`
 * con `formatMessage({id, defaultMessage})` inline — que además no es extraíble.
 * Las llaves `common.month.*` ya existían desde la Fase 1.6; esto solo les pone
 * un sitio único desde donde consumirlas.
 */
const MONTHS = defineMessages({
  january: {id: 'common.month.january', defaultMessage: 'January'},
  february: {id: 'common.month.february', defaultMessage: 'February'},
  march: {id: 'common.month.march', defaultMessage: 'March'},
  april: {id: 'common.month.april', defaultMessage: 'April'},
  may: {id: 'common.month.may', defaultMessage: 'May'},
  june: {id: 'common.month.june', defaultMessage: 'June'},
  july: {id: 'common.month.july', defaultMessage: 'July'},
  august: {id: 'common.month.august', defaultMessage: 'August'},
  september: {id: 'common.month.september', defaultMessage: 'September'},
  october: {id: 'common.month.october', defaultMessage: 'October'},
  november: {id: 'common.month.november', defaultMessage: 'November'},
  december: {id: 'common.month.december', defaultMessage: 'December'},
})

export const MONTH_MESSAGES = [
  MONTHS.january,
  MONTHS.february,
  MONTHS.march,
  MONTHS.april,
  MONTHS.may,
  MONTHS.june,
  MONTHS.july,
  MONTHS.august,
  MONTHS.september,
  MONTHS.october,
  MONTHS.november,
  MONTHS.december,
]
